import type { IBaseAttributes, TConstraints } from '@feathr/rachis';
import { Model } from '@feathr/rachis';

import { EIntegrationTypes } from '../integrations';
import { TargetableClass } from './targetable.types';

export interface ITargetableBase extends IBaseAttributes {
  _cls: TargetableClass;
  name: string;
  integrations?: EIntegrationTypes[];
  partner?: string;
}

export abstract class TargetableBase<T extends ITargetableBase = ITargetableBase> extends Model<T> {
  public static readonly defaults: Partial<ITargetableBase> = {
    integrations: [EIntegrationTypes.Tradedesk],
  };
  public className = 'Targetable';

  public get constraints(): TConstraints<T> {
    return {
      _cls: {
        inclusion: Object.values(TargetableClass),
      },
      name(...args: unknown[]): TConstraints<T> | undefined {
        const attributes = args[1] as T;
        const { _cls: cls } = attributes;
        if (cls === TargetableClass.affinity) {
          return undefined;
        }
        return {
          presence: {
            allowEmpty: false,
          },
        };
      },
    };
  }

  public override getDefaults(): Partial<T> {
    return TargetableBase.defaults as Partial<T>;
  }
}
